<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <h5>
      Historicos movimientos, transferencias y cashback
    </h5>
    <b-spinner variant="info" v-if="pacienteService.loading"/>
    <b-table
        id="recibos"
        thead-tr-class="columnas"
        responsive="true"
        class="parrafos"
        fixed
        show-empty
        v-else
        :fields="fields"
        :items.sync="items">
      <template #empty="scope">
        <p class="alert alert-warning"> No hay datos</p>
      </template>

      <template v-slot:cell(montopagado)="row">
        {{ row.item.montopagado | moneda }}
      </template>
      <template v-slot:cell(saldo)="row">
        {{ row.item.saldo | moneda }}
      </template>
      <template v-slot:cell(aplicacion)="row">
        {{ row.item.aplicacion | moneda }}
      </template>
      <template v-slot:cell(tipoRecibo)="row">
        <b-badge v-if="row.item.tipoRecibo === 1" variant="primary"
        >PTI
        </b-badge
        >
        <b-badge v-else-if="row.item.tipoRecibo === 3" variant="primary"
        >Movimiento Saldo
        </b-badge
        >
        <b-badge v-else-if="row.item.tipoRecibo === 4" variant="primary"
        >Traspaso Saldo
        </b-badge
        >

        <b-badge v-else variant="secondary">Sesión</b-badge>
      </template>
      <template v-slot:cell(Estatus)="row">
        <b-badge v-if="row.item.activo" variant="success">Activo</b-badge>
        <b-badge v-else variant="danger">Cancelado</b-badge>
      </template>
      <template v-slot:cell(fecha)="row">
        {{ row.item.fecha | formatoFechaHora }}
      </template>
      <template v-slot:cell(idRecibo)="row">
        {{
          row.item.numeroRecibo !== null
              ? row.item.numeroRecibo
              : row.item.idRecibo
        }}
      </template>
      <template v-slot:cell(Selec.)="row">
        <b-form-checkbox
            v-if="
                  !row.item.facturado &&
                  row.item.activo &&
                  $localStorageService.can('BT_facturar')
                "
            :id="'checkbox-' + row.item.idRecibo"
            v-model="row.item.seleccion"
            :name="'checkbox-' + row.item.idRecibo"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>
    </b-table>
    <br><br><br><br><br><br><br><br>

  </div>

</template>

<script>
import {PacienteService} from "@/apiServices/paciente/PacienteService";

export default {
  name: "HistorialRecibosVistaDocumentos",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    paciente: null,
    items: [],
    fields: [
      {key: "fecha", label: "Fecha", sortable: true},
      {key: "clinica", label: "Clinica", sortable: true},
      {key: "montopagado", label: "Pago", sortable: true},
      {key: "aplicacion", label: "Aplicacion de saldo", sortable: true},
      {key: "saldo", label: "Saldo", sortable: true},
      {key: "idRecibo", label: "Recibo", sortable: true},
      {key: "tipoRecibo", label: "Tipo", sortable: true},
      "Estatus",
    ],
    pacienteService: new PacienteService(),
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.$root.$on('paciente', (paciente) => {
      this.paciente = paciente;
      this.pacienteService.obtenerRecibosMovimientosTraspasosPorPaciente(paciente.idPaciente).then(recibos => {
        this.items = recibos;
      });
    })
  }
}
</script>

<style scoped>

</style>